import React 		from 'react';
import BLComponent	from '../../core/_BLComponent.jsx';
import moment 			from 'moment';

import CrowdfundingCountdown 	from './_CrowdfundingCountdown.jsx';
import WebinarVideo 	from './_WebinarVideo.jsx';

import {bdpDateFormat} from './_BDPUtilities.jsx';


export default class CountdownIntroBlock extends BLComponent {
	constructor (props, context) {
		super(props, context);
	}

	render() {
		const {series, classes = ''} = this.props;
		const phase = series.phase;

		const isPostValidation = blapp.config.server_time > series.udtCrowdValidationEnd;
		const isInstructionsSeries = blapp.config.server_time >= moment(series.udtProductionStart).subtract(7, 'days') && blapp.config.server_time <= moment(series.udtProductionStart).add(1, 'month');

		if(phase == 'INTAKE') {
			return (
				<section className={`bdp-series-upcoming__intro ${classes}`}>
					<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">Submissions for {series.strName} are now open!</h2>
					<article className="bdp-series-main__announcement-block">
						<div className="bdp-series-main__announcement-block-content">
							<p><strong className="text-color--darkestBlue">We will accept {series.strName} submissions from {bdpDateFormat(series.udtCrowdSourcingStart)} – {bdpDateFormat(series.udtCrowdSourcingEnd)}</strong>. The best designs have the chance to be future BDP {series.strName} sets, so get those ideas flowing!</p>
							<a href={blapp.url2.getCrowdProjectSubmissionsUrl()} className="btn btn--yellow text--bold bdp-series-main__intro-cta">Submit design</a>
						</div>
						<div className="bdp-series-main__intro-block-graphical-container bdp-series-main__announcement-block-graphical-container">
							<h2 className="text--bold l-margin-bottom--sm">Submissions close in</h2>
							<CrowdfundingCountdown classes="bdp-series-main__clock bdp-series-main__clock--announcement-block" end={series.udtCrowdSourcingEnd}/>
						</div>
					</article>
					<WebinarVideo seriesNum={series.idSeries}/>
				</section>
			);
		}else if(phase == 'PRE_VALIDATION') {
			return (
				<section className={`bdp-series-upcoming__intro ${classes}`}>
					<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">Submissions for {series.strName} are now closed.</h2>
					<article className="bdp-series-main__intro-block bdp-series-main__intro-block--voting l-margin-bottom--null">
						<div className="bdp-series-main__intro-block-content bdp-series-main__intro-block-content--center bdp-series-main__intro-block-content--voting">
							<h1 className="bdp-series-main__intro-title bdp-series-main__intro-title--voting">Help us decide which designs will make it!</h1>
							<p className="text-color--darkest80"><strong>The Crowd Support phase starts on {bdpDateFormat(series.udtCrowdValidationStart)}, noon Pacific time.</strong> Vote to support your favorite designs.</p>
						</div>
						<div className="bdp-series-main__intro-block-graphical-container bdp-series-main__intro-block-vote-image">
							<img src={`//${blapp.config.getHost( "static2" )}/img/bdp/voting-open.png`} alt="Votes going into a voting box" className="l-block"/>
						</div>
					</article>
				</section>
			);
		}else if(phase == 'VALIDATION') {
			return (
				<section className={`bdp-series-upcoming__intro ${classes}`}>
					<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">Vote for your favorite fan designs!</h2>
					<article className="bdp-series-main__intro-block bdp-series-main__intro-block--voting l-margin-bottom--null">
						<div className="bdp-series-main__intro-block-content bdp-series-main__intro-block-content--center bdp-series-main__intro-block-content--voting">
							<h1 className="bdp-series-main__intro-title bdp-series-main__intro-title--voting">Help us decide which designs will make it!</h1>
							<p className="text-color--darkest80 l-margin-bottom--xl">Use emoji to vote for as many designs as you wish until <strong>{bdpDateFormat(series.udtCrowdValidationEnd)} at noon Pacific</strong>. Vote tallies are secret.</p>
							<p><a href={blapp.url2.getCrowdSeriesUrl(series.strSlug) + '#submissions'} className="text--underline">View designs</a></p>
						</div>
						<div className="bdp-series-main__intro-block-graphical-container bdp-series-main__intro-block-vote-image">
							<img src={`//${blapp.config.getHost( "static2" )}/img/bdp/voting-open.png`} alt="Votes going into a voting box" className="l-block"/>
						</div>
					</article>
				</section>
			);
		}else if(phase == 'POST_VALIDATION' || (phase == 'WAITING' && isPostValidation)) {
			return (
				<section className={`bdp-series-upcoming__intro ${classes}`}>
					<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">Crowd Support voting is now closed.</h2>
					<article className="bdp-series-main__intro-block bdp-series-main__intro-block--voting l-margin-bottom--null">
						<div className="bdp-series-main__intro-block-content bdp-series-main__intro-block-content--center bdp-series-main__intro-block-content--voting">
							<p className="text-color--darkest80 l-margin-bottom--xl">The BDP Design Team will review all designs and pick 5 finalists. Check back on <strong>{bdpDateFormat(series.udtDesignsAnnounced)}</strong> to find out which we choose!</p>
							<p><a href={blapp.url2.getCrowdSeriesUrl(series.strSlug) + '#submissions'} className="text--underline">View designs</a></p>
						</div>
						<div className="bdp-series-main__intro-block-graphical-container bdp-series-main__intro-block-vote-image">
							<img src={`//${blapp.config.getHost( "static2" )}/img/bdp/voting-open.png`} alt="Votes going into a voting box" className="l-block"/>
						</div>
					</article>
				</section>
			);
		}else if(blapp.config.server_time < series.udtPaletteAdded){
  			return (
  				<section className={`bdp-series-upcoming__intro ${classes}`}>
						<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">Coming Soon: {series.strName} Palette Launch and Webinar</h2>
						<article className="bdp-series-main__announcement-block">
							<div className="bdp-series-main__announcement-block-content">
								<h1 className="text--xl-title l-margin-bottom">Mark your calendar!</h1>
								<p>We’re accepting submissions from <strong className="text-color--darkestBlue">{bdpDateFormat(series.udtCrowdSourcingStart)} – {bdpDateFormat(series.udtCrowdSourcingEnd)} {new Date(series.udtCrowdSourcingEnd).getFullYear()}</strong>. The best designs have the chance to be {series.strName} sets, so get those ideas flowing!</p>
								<a href={blapp.url2.getCrowdProjectGuidelinesUrl(series.idSeries)} className="btn btn--yellow text--bold bdp-series-main__intro-cta">Learn more<i className="fas fa-long-arrow-right l-margin-left--sm"/></a>
							</div>
							<div className="bdp-series-main__intro-block-graphical-container bdp-series-main__announcement-block-graphical-container">
								<h2 className="text--bold l-margin-bottom--sm">Palette releases in</h2>
								<CrowdfundingCountdown classes="bdp-series-main__clock bdp-series-main__clock--announcement-block" end={series.udtPaletteAdded}/>
							</div>
						</article>
					</section>
  			);
		}else if(phase == 'UPCOMING') {
			return (
					<section className={`bdp-series-upcoming__intro`}>
						<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">{series.strName} palette is now live!</h2>
						<article className="bdp-series-main__announcement-block">
							<div className="bdp-series-main__announcement-block-content">
								<h1 className="text--xl-title l-margin-bottom">Start designing for {series.strName}.</h1>
								<p>We’re accepting submissions from <strong className="text-color--darkestBlue">{bdpDateFormat(series.udtCrowdSourcingStart)} – {bdpDateFormat(series.udtCrowdSourcingEnd)} {new Date(series.udtCrowdSourcingEnd).getFullYear()}</strong>. The best designs have the chance to be {series.strName} sets, so get those ideas flowing!</p>
								<a href={blapp.url2.getCrowdProjectGuidelinesUrl(series.strSlug)} className="btn btn--yellow text--bold bdp-series-main__intro-cta">Learn more <i className="fas fa-long-arrow-right"/></a>
							</div>
							<div className="bdp-series-main__intro-block-graphical-container bdp-series-main__announcement-block-graphical-container">
								<h2 className="text--bold l-margin-bottom--sm">Submit your design in</h2>
								<CrowdfundingCountdown classes="bdp-series-main__clock bdp-series-main__clock--announcement-block" end={series.udtCrowdSourcingStart}/>
							</div>
						</article>
						<WebinarVideo seriesNum={series.idSeries}/>
					</section>
			);
		}else if(isInstructionsSeries) {
			return (
				<div className="bdp-series-instructions">
					<div className="bdp-series-instructions__text">
						<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">Start building BDP {series.strName} sets!</h2>
						<p className="bdp-series-main__announcement-intro bdp-series-main__announcement-intro--finalists-landing">Building instructions are now available on the LEGO® Builder App and via downloadable PDF!</p>
					</div>
					<div className="bdp-series-instructions__graphic">
						<div className="building-instructions-modal__first-app-container l-margin-null">
							<div className="building-instructions-modal__first-app-image">
								<img className="l-block" src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/devices_desktop-tall.png"} alt="LEGO&reg; Builder app on iPad and iPhone screens"/>
							</div>
							<div className="building-instructions-modal__first-apps l-pad-x--null">
								<div className="building-instructions-modal__first-apps-list">
									<a className="building-instructions-modal__first-app-item" href="https://apps.apple.com/us/app/lego-building-instructions/id1486159728" target="_blank">
										<img src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/badge_apple.svg"} alt="Download on the Apple App Store"/>
									</a>
									<a className="building-instructions-modal__first-app-item" href="https://play.google.com/store/apps/details?id=com.lego.legobuildinginstructions" target="_blank">
										<img src={"//" + blapp.config.getHost( "static2" ) + "/img/bdp/building-modal/badge_google.svg"} alt="Get it on Google Play"/>
									</a>
								</div>
							</div>
						</div>
					</div>
					<a href={blapp.url2.getCrowdSeriesUrl(series.strSlug)} className="btn bg-color--white text-color--darkestBlue text--small-title text--bold bdp-series-instructions__cta">Go to {series.strName}<i className="fas fa-long-arrow-right l-margin-left"/></a>
				</div>
			);
		}else if(phase == 'CLOSED') {
			return false;
		}else{
			return (
				<section className={`bdp-series-upcoming__intro ${classes}`}>
					<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">Submissions for {series.strName} opens {bdpDateFormat(series.udtCrowdSourcingStart)}</h2>
					<article className="bdp-series-main__announcement-block">
						<div className="bdp-series-main__announcement-block-content">
							<p><strong className="text-color--darkestBlue">We will accept {series.strName} submissions from {bdpDateFormat(series.udtCrowdSourcingStart)} – {bdpDateFormat(series.udtCrowdSourcingEnd)}</strong>. The best designs have the chance to be future BDP {series.strName} sets, so get those ideas flowing!</p>
							<a href={blapp.url2.getCrowdProjectGuidelinesUrl(series.strSlug)} className="btn btn--yellow text--bold bdp-series-main__intro-cta">View submission guidelines</a>
						</div>
						<div className="bdp-series-main__intro-block-graphical-container bdp-series-main__announcement-block-graphical-container">
							<h2 className="text--bold l-margin-bottom--sm">Submissions open in</h2>
							<CrowdfundingCountdown classes="bdp-series-main__clock bdp-series-main__clock--announcement-block" end={series.udtCrowdSourcingStart}/>
						</div>
					</article>
				</section>
			);
		}
	}
}